import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

export const AccommodationPackageTileGrid = styled.div`
  padding: ${rem(16)};
  display: grid;
  gap: ${rem(12)} ${rem(32)};
  border: 1px solid ${props => props.theme.palette.neutral.default.six};
  grid-template:
    "banner" auto
    "details" 1fr
    "pricing" auto / 1fr;

  ${mediaQueryUp.tablet} {
    padding: ${rem(20)};
    border: none;
    grid-template:
      "banner details pricing" auto / ${rem(300)} 1fr ${rem(250)};
  }
`

function AccommodationSameRoomOptionTile(props: PropsWithChildren) {
  return <AccommodationPackageTileGrid {...props} />
}

export default AccommodationSameRoomOptionTile
